export default {
    gutter: 0.5,
    padding: 1.45,
    height: 17.5,
};
